import { ChangeEvent, Component } from 'react';
import track from 'react-tracking';
import { Button } from '@simplywallst/ui-core';
import { ActionRow } from './styled';
import { Checkbox } from '@components/Checkbox';
import { Column } from '@simplywallst/ui-core';
import AddTransactionsModal from '../AddTransactionsModal';

export interface FetchPriceArgs {
  itemId?: string;
  companyId?: string;
  requestDate: Date;
}

export interface AddTransactionArgs {
  portfolioId: string;
  companyId: string;
  itemId: string;
  type: string;
  date: number;
  shares: string;
  cost: number;
}

export interface UpdateReinvestArgs {
  portfolioId: string;
  companyId: string;
  itemId: string;
  reinvest: boolean;
}

interface Props {
  portfolioId: string;
  itemId: string;
  companyId: string;
  itemPrices: Record<string, number>;
  tickerSymbol: string;
  handleAddTransaction: (options: AddTransactionArgs) => void;
  handleFetchPrice: (options: FetchPriceArgs) => void;
  handleUpdateReinvest: (options: UpdateReinvestArgs) => void;
  isFetchingPrice: boolean;
  isAddingTransaction?: boolean;
  reinvestDividends?: boolean;
  isUpdatingReinvest?: boolean;
}

interface State {
  reinvestDividend: boolean;
  isVisible: boolean;
}

@track({
  type: 'track',
})
class AddTransactions extends Component<Props, State> {
  static defaultProps = {
    itemPrices: {},
    handleFetchPrice: () => null,
    isFetchingPrice: false,
    isAddingTransaction: false,
  };

  state = {
    reinvestDividend: false,
    isVisible: false,
  };

  handleReInvestDividendChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { checked },
    } = e;

    const { portfolioId, itemId, companyId, handleUpdateReinvest } = this.props;

    handleUpdateReinvest &&
      handleUpdateReinvest({
        portfolioId,
        itemId,
        companyId,
        reinvest: checked,
      });
  };

  @track({
    action: 'click',
    modifier: 'addTransaction',
  })
  showAddTxnModal = () => {
    this.setState({ isVisible: true });
  };

  closeAddTxnModal = () => {
    this.setState({ isVisible: false });
  };

  render() {
    const {
      isFetchingPrice,
      reinvestDividends,
      isUpdatingReinvest,
      tickerSymbol,
      handleAddTransaction,
      handleFetchPrice,
      portfolioId,
      itemId,
      companyId,
      itemPrices,
    } = this.props;

    const { isVisible } = this.state;

    const { handleReInvestDividendChange, closeAddTxnModal, showAddTxnModal } =
      this;

    return (
      <>
        <ActionRow>
          <Column col={12}>
            <Checkbox
              name="reinvest-dividends"
              invert={true}
              value={reinvestDividends as boolean}
              label="Reinvest Dividends"
              onChange={handleReInvestDividendChange}
              disabled={isUpdatingReinvest}
            />
          </Column>
        </ActionRow>
        <ActionRow>
          <Column col={12} colSm={4}>
            <Button
              styleType="louder"
              marginTop
              marginRight
              onClick={showAddTxnModal}
              data-cy-id="add-transaction"
            >
              Add Transaction
            </Button>
          </Column>
        </ActionRow>
        {isVisible && (
          <AddTransactionsModal
            portfolioId={portfolioId}
            itemId={itemId}
            companyId={companyId}
            itemPrices={itemPrices}
            tickerSymbol={tickerSymbol}
            handleClose={closeAddTxnModal}
            handleAdd={handleAddTransaction}
            handleFetchPrice={handleFetchPrice}
            isFetchingPrice={isFetchingPrice}
          />
        )}
      </>
    );
  }
}

export default AddTransactions;
